export const TAB_APPROVE_SKILL = "approve-skills";
export const TAB_PLAYBOOKS = "playbooks";
export const TAB_PARTNERS = "partners";
export const TAB_EXPERTS = "experts";
export const TAB_APPLICANTS = "Applicants";

export const PENDING_EXPERTS = "Pending Experts";
export const PENDING_PARTNERS = "Pending Partners";
